/* eslint-disable no-shadow */
/* eslint-disable import/no-useless-path-segments */

import firebase from 'firebase/app';
import router from '../../../src/router/router';
import 'firebase/auth';
import 'firebase/firestore';

const state = {
  fbaseAuth: false,
  userId: null,
  firstName: null,
  lastName: null,
  email: null,
  phone: null,
  city: null,
  disabledAdmin: false,
  badgeNumber: null,
  routedNewUser: false,
  providers: [],
  customers: [],
  customersCount: 0,
  providersCount: 0,
  // ──────────────────────────────────────────────────────────────────
  // REMOVED - Phone/SMS auth state (replaced with Google Sign-In)
  // ──────────────────────────────────────────────────────────────────
  // showVerifyCode: false,
  // verifyError: false,
  // smsFailed: false,
  // phoneExists: null,
  // phoneSearched: null,
};

const getters = {
  userId: (state) => state.userId,
  phone: (state) => state.phone,
  email: (state) => state.email,
  isAuthenticated: (state) => state.fbaseAuth,
  userName: (state) => `${state.firstName} ${state.lastName}`,
  city: (state) => state.city,
  badgeNumber: (state) => state.badgeNumber,
  providers: (state) => state.providers,
  providersCount: (state) => state.providersCount,
  customers: (state) => state.customers,
  customersCount: (state) => state.customersCount,
  // ──────────────────────────────────────────────────────────────────
  // REMOVED - Phone/SMS auth getters
  // ──────────────────────────────────────────────────────────────────
  // showVerifyCode: (state) => state.showVerifyCode,
  // verifyError: (state) => state.verifyError,
  // phoneExists: (state) => state.phoneExists,
  // phoneSearched: (state) => state.phoneSearched,
  // smsFailed: (state) => state.smsFailed,
};

const mutations = {
  storeUserInfo: (state, authData) => {
    state.userId = authData.userId;
    state.email = authData.email;
    state.phone = authData.phone;
    state.firstName = authData.firstName;
    state.lastName = authData.lastName;
    state.city = authData.city;
    state.badgeNumber = authData.badgeNumber;
    state.disabledAdmin = authData.disabled == null ? false : authData.disabled;
  },
  verifyLogin(state) {
    // CHANGED: Replaced ternary with !! for ESLint compliance (no-unneeded-ternary)
    // OLD: (firebase.auth().currentUser && state.badgeNumber && !state.disabledAdmin)
    //        ? state.fbaseAuth = true : state.fbaseAuth = false;
    state.fbaseAuth = !!(firebase.auth().currentUser && state.badgeNumber && !state.disabledAdmin);
  },
  localVerifyLogin(state) {
    state.fbaseAuth = true;
  },
  setUserId(state, userId) {
    state.userId = userId;
  },
  logOutCleanUp(state) {
    state.fbaseAuth = false;
    state.userId = null;
    state.firstName = null;
    state.lastName = null;
    state.email = null;
    state.phone = null;
    state.city = null;
    state.badgeNumber = null;
    state.disabledAdmin = false;
    localStorage.removeItem('userInfo');
  },
  providersCountUpdate(state, count) {
    state.providersCount = count;
  },
  providersLocUpdate(state, locs) {
    state.providers = [...locs];
  },
  customersCountUpdate(state, count) {
    state.customersCount = count;
  },
  customersLocUpdate(state, locs) {
    state.customers = [...locs];
  },
  // ──────────────────────────────────────────────────────────────────
  // REMOVED - Phone/SMS auth mutations
  // ──────────────────────────────────────────────────────────────────
  // smsSuccessUpdate(state) {
  //   state.showVerifyCode = true;
  //   state.verifyError = false;
  //   state.smsFailed = false;
  // },
  // signInRouteUpdate(state) {
  //   state.showVerifyCode = false;
  //   state.verifyError = null;
  //   state.smsFailed = null;
  //   state.routedNewUser = true;
  // },
  // smsFailureUpdate(state) {
  //   state.smsFailed = true;
  // },
  // signInFailureUpdate(state) {
  //   state.verifyError = true;
  //   state.showVerifyCode = false;
  // },
  // phoneSearchUpdate(state) {
  //   state.phoneSearched = true;
  // },
  // phoneExistence(state, doc) {
  //   state.phoneExists = doc.exists;
  // },
};

const actions = {
  // checkLogin now called from component after Google Sign-In
  checkLogin({ dispatch }, badgeNumber) {
    if (!badgeNumber) return;
    const loggedUser = firebase.auth().currentUser;
    if (!loggedUser) {
      console.warn('Authentication required');
      return;
    }
    dispatch('loadUserData', { uid: loggedUser.uid, badgeNumber });
  },

  // CHANGED - Added disabled check, removed sensitive logging
  loadUserData({ commit }, onboardAuth) {
    firebase
      .firestore()
      .collection('gdoAdmins')
      .doc(onboardAuth.badgeNumber)
      .get()
      .then((doc) => {
        if (doc.exists) {
          const data = doc.data();
          // NEW: Security check - block disabled admins at backend level
          if (data.disabled) {
            console.warn('Account is disabled');
            return;
          }
          const userInfo = {
            userId: onboardAuth.uid,
            email: data.email,
            phone: data.phone,
            firstName: data.firstName,
            lastName: data.lastName,
            city: data.city,
            disabled: data.disabled,
            badgeNumber: onboardAuth.badgeNumber,
          };
          const now = new Date();
          // CHANGED: 100 hours → 3 days session expiry
          const loginExpirationDate = new Date(now.getTime() + 3 * 24 * 60 * 60 * 1000);
          commit('storeUserInfo', userInfo);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          localStorage.setItem('loginExpirationDate', loginExpirationDate);
          commit('verifyLogin');
          router.push('/followup');
        } else {
          console.warn('Invalid credentials');
        }
      })
      .catch((error) => {
        console.error('Authentication error:', error.code);
      });
  },

  // Session persistence logic identical
  persistSession({ dispatch, commit }) {
    const storedUserInfo = JSON.parse(localStorage.getItem('userInfo'));
    const loginExpiration = localStorage.getItem('loginExpirationDate');
    const now = new Date();
    if (!storedUserInfo) return;
    if (now >= Date.parse(loginExpiration)) {
      localStorage.removeItem('userInfo');
      localStorage.removeItem('loginExpirationDate');
      console.log('Session expired');
      return;
    }
    commit('storeUserInfo', storedUserInfo);
    if (!storedUserInfo.disabled) {
      commit('localVerifyLogin');
    } else {
      dispatch('signOut');
    }
  },

  signOut({ commit }) {
    firebase
      .auth()
      .signOut()
      .then(() => console.log('Signed out'))
      .catch((error) => console.error('Sign out error:', error.code));
    commit('logOutCleanUp');
  },

  // Map data for providers/customers
  appUsers({ commit }) {
    firebase
      .firestore()
      .collection('users')
      .get()
      .then((querySnapshot) => {
        const locations = [];
        const customersLocations = [];
        let providersCount = 0;
        let customersCount = 0;
        querySnapshot.forEach((doc) => {
          if (doc.data().serviceProvider === true) {
            locations.push({
              lat: doc.data().geoLoc.geopoint.latitude,
              lng: doc.data().geoLoc.geopoint.longitude,
            });
            providersCount += 1;
          } else {
            customersLocations.push({
              lat: doc.data().geoLoc.geopoint.latitude,
              lng: doc.data().geoLoc.geopoint.longitude,
            });
            customersCount += 1;
          }
        });
        commit('providersLocUpdate', locations);
        commit('providersCountUpdate', providersCount);
        commit('customersLocUpdate', customersLocations);
        commit('customersCountUpdate', customersCount);
      })
      .catch((error) => {
        console.error('Error loading users:', error.code);
      });
  },

  // ════════════════════════════════════════════════════════════════════
  // REMOVED - Phone/SMS authentication actions (replaced with Google Sign-In)
  // ════════════════════════════════════════════════════════════════════
  // smsAuthenticate({ dispatch }, phoneNumber) {
  //   firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  //     .then(() => dispatch('sendSMSToken', phoneNumber))
  //     .catch((error) => {
  //       console.log('sms auth error code :', error.code, ' message :', error.message);
  //     });
  // },
  //
  // sendSMSToken({ commit }, phoneNumber) {
  //   firebase.auth().signInWithPhoneNumber(phoneNumber, window.recaptchaVerifier)
  //     .then((confirmationResult) => {
  //       window.confirmationResult = confirmationResult;
  //       console.log('SMS is sent!');
  //       commit('smsSuccessUpdate');
  //     })
  //     .catch((error) => {
  //       console.log('error sending sms', error);
  //       alert('Error : SMS code is not sent!\n', error);
  //       commit('smsFailureUpdate');
  //     });
  // },
  //
  // signIn({ dispatch, commit }, loginData) {
  //   window.confirmationResult.confirm(loginData.verifyCode).then((result) => {
  //     commit('setUserId', result.user.uid);
  //     dispatch('checkLogin', loginData.badgeNumber);
  //   }).catch((error) => {
  //     console.log('bad verification code, try again', error.message);
  //     alert('The verification code is wrong! Try again');
  //     commit('signInFailureUpdate');
  //   });
  // },
  //
  // phoneLookup({ commit, state }) {
  //   firebase.firestore().collection('gdoAdmins').doc(state.userId).get()
  //     .then((doc) => {
  //       commit('phoneSearchUpdate');
  //       commit('phoneExistence', doc);
  //     })
  //     .catch((error) => {
  //       console.log('phonelookup - error searching phone number', error);
  //     });
  // },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
